import { configureStore } from "@reduxjs/toolkit";
import configSlice from "./slice/configSlice";
import applicationSlice from "./slice/applicationSlice";
import userSlice from "./slice/userSlice";

export const store = configureStore({
  reducer: {
    configSlice,
    applicationSlice,
    userSlice,
  },
});
